module.exports = __webpack_public_path__ + "static/media/buy_req_make_10.b58cc36f.jpg";